import { render } from "./addGalleryFiles.vue?vue&type=template&id=712bfaca"
import script from "./addGalleryFiles.vue?vue&type=script&lang=js"
export * from "./addGalleryFiles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__